/** 16×16 像素宝箱 */

export function drawPixelChest (ctx, originX, originY, scale, open = false) {
  const ox = Math.floor(originX)
  const oy = Math.floor(originY)
  const s = scale
  ctx.imageSmoothingEnabled = false

  const fill = (x, y, w, h, color) => {
    ctx.fillStyle = color
    ctx.fillRect(ox + x * s, oy + y * s, w * s, h * s)
  }

  if (!open) {
    fill(4, 6, 8, 7, '#8B4513')
    fill(5, 7, 6, 5, '#A0522D')
    fill(4, 5, 8, 2, '#D4A017')
    fill(5, 5, 6, 1, '#F1C40F')
    fill(7, 8, 2, 2, '#F1C40F')
    fill(7, 5, 2, 1, '#8B6914')
    return
  }

  // 箱盖掀起
  fill(2, 3, 3, 2, '#A0522D')
  fill(3, 1, 10, 3, '#D4A017')
  fill(4, 0, 8, 2, '#F1C40F')
  fill(11, 3, 2, 2, '#8B4513')
  // 箱体敞口
  fill(4, 6, 8, 2, '#6b3a1f')
  fill(5, 7, 6, 5, '#3d2517')
  fill(5, 7, 6, 2, '#2a1810')
  // 箱内金币
  fill(5, 7, 2, 2, '#f1c40f')
  fill(8, 7, 2, 2, '#d4a017')
  fill(6, 8, 3, 2, '#ffe066')
  fill(5, 9, 2, 1, '#d4a017')
  fill(9, 9, 2, 1, '#f1c40f')
  fill(7, 5, 2, 1, '#8B6914')
}
